/* stylelint-disable */
// TODO fix stylelint disable!
import { Box } from '@gmg/gmg-react-components';
import { FC } from 'react';
import styled from 'styled-components';

export interface Options {
    isFixed?: boolean;
    value: string;
    label: string;
}
export interface SelectElementWrapperProps {
    label: string;
    height?: string;
    children: React.ReactNode;
    variant?: 'small' | 'normal';
    error?: string;
}

const LabelContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  border-bottom: 2px solid ${(props) => props.theme.colors.backgroundPaper};
  padding: 0px 16px 4px 24px;
`;

const StyledLabel = styled.label`
  box-sizing: border-box;
  height: 20px;
`;

const ControlContainer = styled.div<SelectElementWrapperProps>`
  box-sizing: border-box;
  margin-bottom: 24px;
  height:${props => props.height ? props.height : '150px'};
  padding: 8px 24px 0 24px;
`;

const FormElementWrapper: FC<SelectElementWrapperProps> = props => {

    return (
        <Box width={props.variant === 'small' ? '50%' : '100%'}>
            <LabelContainer>
                <StyledLabel className="px10_600_normal">
                    {props.label}
                </StyledLabel>
            </LabelContainer>
            <ControlContainer {...props}>
                {props.children}
                <div className={'px9_400_error'}>{props.error}</div>
            </ControlContainer>

        </Box>
    );
};

export default FormElementWrapper;
